import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';

@Component({
  selector: 'component-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css','../../../styles.scss']
})
export class FooterComponent implements OnInit {
  constructor(@Inject(DOCUMENT) private document:Document,
   @Inject(PLATFORM_ID) private platformId: Object) { }

  protected referalCode:string=this.getCookie('referenceBhavani');
  platformBaseUrl = $localize.locale ==='es'? `https://my.bhavani.app/es/`: `https://my.bhavani.app/en/`
  baseLink = $localize.locale === 'es'?'https://bhavani.app/en/r/':'https://bhavani.app/es/r/';
  changeLanLink:string = this.baseLink += this.referalCode;
  changeLanText:string = $localize`Change language to English`;
  footer_links= [
    {
      top_link_name: $localize`Acerca de`,
      top_link_path: "/about",
      sub_links: 
        [
          {
            name: `Instagram`,
            path:'https://www.instagram.com/bhavani_wellness/',
            external:true
          },
          {
            name: $localize`Mi perfil`,
            path: this.platformBaseUrl,
            external: true,
          },
          {
            name: $localize`Acerca de`,
            path: "/about",
            external: false,
          },
          // {
          //   name: $localize`Blog`,
          //   path: "/blog",
          // external: false,
          // },
          {
            name: $localize`Nuestras investigaciones`,
            path: "/treatment",
            fragment:"scientificResearch",
            external: false,
          },
        ]
    },
    {
      top_link_name: $localize`La Microdosis`,
      top_link_path: "/",
      sub_links: 
        [
          {
            name: $localize`Beneficio`,
            path: "/dosage/benefits",
            external: false,
          },
          {
            name: $localize`Fórmulas`,
            path: "/dosage/formula",
            external: false,
          },
          {
            name: $localize`Espectro de Luz`,
            path: "/dosage/spectrum",
            external: false,
          },
          {
            name: $localize`Protocolo`,
            path: "/dosage/protocol",
            external: false,
          },
        ]
    },
    {
      top_link_name: $localize`El Tratamiento`,
      top_link_path: "/",
      sub_links: 
        [
          {
            name: $localize`Tratamiento`,
            path: "/treatment",
            external: false,
          },
          {
            name: $localize`Coaches`,
            path: "/coaches",
            external: false,
          },
          {
            name: $localize`Terapia`,
            path: "/therapeutic-support",
            external: false,
          },
          {
            name: $localize`Preguntas Frecuentes`,
            path: "/faq",
            external: false,
          },
        ]
    },
  
  ];
  private getCookie(name: string) {
    if (!isPlatformBrowser(this.platformId)) return '';
    let ca: Array<string> = this.document.cookie.split(';');
    let caLen: number = ca.length;
    let cookieName = `${name}=`;
    let c: string;

    for (let i: number = 0; i < caLen; i += 1) {
      c = ca[i].replace(/^\s+/g, '');
      if (c.indexOf(cookieName) == 0) {
        return c.substring(cookieName.length, c.length);
      }
    }
    return '';
  }
  ngOnInit(): void {
  }

}
